// FILE: frontend/src/pages/RefundPolicy.tsx
import { Link } from "react-router-dom";

export default function RefundPolicy() {
  return (
    <div className="mx-auto max-w-4xl space-y-6 p-6 text-slate-900 dark:text-slate-100">
      <div>
        <h1 className="text-3xl font-bold">Refund & Credit Policy</h1>
        <p className="mt-2 text-sm text-slate-500 dark:text-slate-400">
          Last updated: September 12, 2026
        </p>
      </div>

      <section className="card space-y-3 p-6">
        <p className="text-sm text-slate-700 dark:text-slate-300">
          AutoQuiz AI is operated by MC SANTE PLUS SERVICES LLC.
        </p>
      </section>

      <section className="card space-y-3 p-6">
        <h2 className="text-xl font-semibold">Prepaid Credits</h2>
        <p className="text-sm text-slate-700 dark:text-slate-300">
          AutoQuiz AI uses prepaid credits for paid video generation. Credit
          packs are one-time purchases and are added to your account wallet
          after successful payment processing.
        </p>
        <p className="text-sm text-slate-700 dark:text-slate-300">
          Unused credits remain in your wallet and do not reset on a monthly
          billing cycle.
        </p>
      </section>

      <section className="card space-y-3 p-6">
        <h2 className="text-xl font-semibold">Failed Video Renders</h2>
        <p className="text-sm text-slate-700 dark:text-slate-300">
          When credits are reserved for a video render and that render fails,
          the reserved render credits are returned to your wallet.
        </p>
      </section>

      <section className="card space-y-3 p-6">
        <h2 className="text-xl font-semibold">Credit-Pack Purchase Refunds</h2>
        <p className="text-sm text-slate-700 dark:text-slate-300">
          Refund requests for purchased credit packs are reviewed according to
          applicable law and the circumstances of the request. Refunds are not
          guaranteed merely because credits are unused.
        </p>
        <p className="text-sm text-slate-700 dark:text-slate-300">
          If a credit-pack payment is refunded, reversed, or charged back, the
          credits associated with that payment may be removed from the account.
          If those credits were already used, the account balance may become
          negative until sufficient credits are added again.
        </p>
        <p className="text-sm text-slate-700 dark:text-slate-300">
          For billing or refund questions, contact{" "}
          <a
            href="mailto:services@findtheideas.com"
            className="underline hover:no-underline"
          >
            services@findtheideas.com
          </a>
          .
        </p>
      </section>

      <p className="text-sm text-slate-500 dark:text-slate-400">
        See also our{" "}
        <Link to="/terms" className="underline hover:no-underline">
          Terms of Service
        </Link>{" "}
        and{" "}
        <Link to="/privacy" className="underline hover:no-underline">
          Privacy Policy
        </Link>
        .
      </p>
    </div>
  );
}
